import { useMe } from "./me";

/** Whether the person signed in has a feature that ships behind a switch
 * (Admin → Feature switches; the list is the backend's core/features.py).
 * False until /api/me has loaded, so a switched feature never flashes up for
 * someone who doesn't have it. */
export function useFeature(key: string): boolean {
  const { data: me } = useMe();
  return !!me?.features?.[key];
}
